/*
 * JS to capture changing selling plans on Tequila Club page
*/

const personalBuyNow = document.querySelectorAll('[data-club-buy-now]'),
      giftBuyNow = document.querySelectorAll('[data-gift-buy-now]');

function getValues(id, selling_plan) {
  let formData = {
    'items': [{
      'id': id,
      'quantity': 1,
      'selling_plan': selling_plan
      }]
    };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  setTimeout(function() {
    window.location.href = '/cart';
  }, 1000);
}

personalBuyNow?.forEach(button => {
  button.addEventListener('click', function() {
    let parentContainer = button.closest('.prose');
    let personalSelect = parentContainer.querySelector('[data-club-select]')
    let sellingPlanID = personalSelect.value;
    getValues(42405057986749, sellingPlanID);
  })
})

giftBuyNow?.forEach(button => {
  button.addEventListener('click', function() {
    let parentContainer = button.closest('.prose');
    console.log("P: ", parentContainer);
    let giftSelect = parentContainer.querySelector('[data-gift-select]');
    console.log("Gift: ", giftSelect);
    let sellingPlanID = giftSelect.value;
    getValues(42437611290813, sellingPlanID);
  })
})

/* PDP JS */

const subscriptionRadioButtons = document.querySelectorAll('[data-selling-plan-input]');
const productForm = document.querySelector('[data-product-form]');
const newInput = document.createElement('input');

const subFrequency = document.querySelector('.sub-frequency');
const radioSubSelects = document.querySelectorAll('[data-subscription-frequency]');
const onetimepurchaseSelector = document.getElementById('onetimepurchaseSelector');
const subscriptionSelector = document.getElementById('subscriptionSelector');
const paymentBoxRows = document.querySelectorAll('.payment-box-row');

// Make entire row clickable to trigger radio button
paymentBoxRows?.forEach(row => {
  row.addEventListener('click', function(e) {
    // Don't trigger if clicking on the radio input itself (avoid double-trigger)
    if (e.target.matches('[data-selling-plan-input]')) return;

    const radio = row.querySelector('[data-selling-plan-input]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('click', { bubbles: true }));
    }
  });
});

// Create Selling Plan Input

function addSellingPlanInput(form) {
  newInput.type = 'hidden';
  newInput.name = "selling_plan";
  newInput.setAttribute('data-selling-plan-value', "");

  form.appendChild(newInput);
}

if(productForm) {
  addSellingPlanInput(productForm);

  // If subscription-only (no one-time option), pre-populate the selling plan value
  if (!onetimepurchaseSelector && subscriptionSelector) {
    const checkedFrequency = document.querySelector('[data-subscription-frequency]:checked');
    if (checkedFrequency) {
      newInput.value = checkedFrequency.value;
    }
  }
}

subscriptionRadioButtons?.forEach(button => {
  button.addEventListener('click', function () {
    let buttonValue = button.getAttribute('data-selling-plan-input');

    if (buttonValue === "") {
      newInput.value = "";
      subFrequency?.classList.remove('active');
      onetimepurchaseSelector?.classList.add('active');
      subscriptionSelector?.classList.remove('active');
    } else {
      const checkedRadioSubSelect = Array.from(radioSubSelects).find(radio => radio.checked);
      if (checkedRadioSubSelect) {
        newInput.value = checkedRadioSubSelect.value;
      }
      onetimepurchaseSelector?.classList.remove('active');
      subscriptionSelector?.classList.add('active');
      subFrequency?.classList.add('active');
    }
  });
});

radioSubSelects?.forEach(radioSubSelect => {
  radioSubSelect.addEventListener('change', function () {
    newInput.value = radioSubSelect.value;
  });
});







